/*  eslint-disable no-unused-vars  */
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
// import i18n from './i18n';

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
import VueObserveVisibility from "vue-observe-visibility";
Vue.use(VueObserveVisibility)
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

new Vue({
  router,
  // i18n,
  store,

  render: (h) => h(App),
}).$mount("#app");
